import { render, staticRenderFns } from "./AssembledUprightsInfo.vue?vue&type=template&id=4f88aa51"
import script from "./AssembledUprightsInfo.vue?vue&type=script&lang=js"
export * from "./AssembledUprightsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports